import { createSelector } from 'react-sweet-state';

import type { FormRendererState } from '../../types';

export const renderModeSelector: import('react-sweet-state').OutputSelector<
	FormRendererState,
	void,
	import('../../../..').FormRenderMode
> = createSelector(
	(state: FormRendererState) => state.renderMode,
	(renderMode) => renderMode,
);
